import { BiSolidEdit } from 'react-icons/bi';
import ExpandableCard from '../../../components/ExpandableCard/ExpandableCard';
import styles from './Observations.module.css';

export default function Observations() {
  return (
    <div className={styles.Observations}>
      <ExpandableCard
        headerTitle={'Title 1'}
        headerIcon={<BiSolidEdit size={20} />}
      />
      <ExpandableCard
        headerTitle={'Title 1'}
        headerIcon={<BiSolidEdit size={20} />}
      />
      <ExpandableCard
        headerTitle={'Title 1'}
        headerIcon={<BiSolidEdit size={20} />}
      />
      <ExpandableCard
        headerTitle={'Title 1'}
        headerIcon={<BiSolidEdit size={20} />}
      />
      <ExpandableCard
        headerTitle={'Title 1'}
        headerIcon={<BiSolidEdit size={20} />}
      />
      <ExpandableCard
        headerTitle={'Title 1'}
        headerIcon={<BiSolidEdit size={20} />}
      />
    </div>
  );
}
